import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  getEditIngredient,
  changeMenuValue,
  checkSupplierDetails,
  getConversionMultiplier,
  menuInitialValue,
  saveStorageAreaDetails,
  showAlert,
  changeIngredientStatus,
} from "../../../../Redux/actions";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import {
  changeDateFormat,
  checkArray,
  checkNull,
  createSelectOptions,
  decimalValue,
  getMerchantCurrencySymbol,
} from "../../../../helpers";
import {
  saveMenuIngredientDetails,
  getInventoryUom,
  saveBackupIngredient,
  getBackupIngredient,
} from "../../../../Redux/actions/menuActions";
import ModelContainer from "../../../Components/ModelContainer";
import ErrorContainer from "../../../Components/ErrorContainer";
import ListInput from "../../../Components/ListInput";
import ListSelect from "../../../Components/ListSelect";
import ListDateInput from "../../../Components/ListDateInput";
import moment from "moment";

const EditIngredient = (params) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.authReducer.user_details);
  const {
    ingredient_details,
    ingreMeasureUnitModal,
    check_supplier_details,
    storageAreaModalModal,
    is_add_storage_loading,
    ingredient_conversion_details,
    add_storage_new_id,
    is_redirect_menu_ingredient,
    backupIngredientModal,
    inventory_uom_details,
    backup_ingredient_list,
    backupIngredientModal_loading,
  } = useSelector((state) => state.menuReducer);
  const formButtonRef = useRef(null);

  const convValidator = {
    id: yup.string().nullable(),
    supplier_id: yup.string().required(),
    link_type: yup.string().nullable(),
    linked_inventory_id: yup.string().nullable(),
    linked_supplier_id: yup.string().nullable(),
    measurement_unit_id: yup.string().required(),
    new_measurement_unit: yup.string().when("measurement_unit_id", {
      is: "add_new",
      then: yup.string().required(),
    }),
    purchase_price: yup.number().positive().required(),
    min_order_qty: yup.string().required(),
    con_multiplier: yup.number().positive().required(),
    measurement_price: yup.number().positive().required(),
    deal_available: yup.string().required(),
    every_buy: yup.string().when("deal_available", {
      is: "add_new",
      then: yup.string().required(),
    }),
    you_get: yup.string().when("deal_available", {
      is: "add_new",
      then: yup.string().required(),
    }),
  };
  // if (check_supplier_details == 1) {
  //   convValidator.link_type = yup.string().required();
  //   convValidator.linked_inventory_id = yup.string().required();
  // }
  const addIngredientSchema = yup
    .object({
      id: yup.string().required(),
      status: yup.boolean().required(),
      ingredient_name: yup.string().required(),
      category_id: yup.string().required(),
      measurement_unit_id: yup.string().required(),
      non_cogs: yup.string().required(),
      applicable_to: yup.string().required(),
      description: yup.string().required(),
      storage_area_1_id: yup.string().required(),
      storage_area_2_id: yup.string().required(),
      notes: yup.string().required(),
      ingredient_conv_multiplier: yup
        .array()
        .of(yup.object().shape(convValidator)),
    })
    .required();

  useEffect(() => {
    dispatch(getEditIngredient(`/${id}`));
    dispatch(getBackupIngredient(`/${id}`));
    return () => {
      dispatch(menuInitialValue());
    };
  }, []);

  useEffect(() => {
    if (is_redirect_menu_ingredient) {
      history.goBack();
    }
  }, [is_redirect_menu_ingredient]);

  useEffect(() => {
    if (ingredient_details?.ingredient) {
      const editDetail = ingredient_details?.ingredient;
      const newEditDetail = {
        id: checkNull(editDetail?.id),
        status: editDetail?.status?.status == "Active" ? 1 : 0,
        ingredient_name: checkNull(editDetail?.ingredient_name),
        category_id: checkNull(editDetail?.category_id),
        measurement_unit_id: checkNull(editDetail?.measurement_unit_id),
        non_cogs: checkNull(editDetail?.non_cogs),
        applicable_to: checkNull(editDetail?.applicable_to),
        description: checkNull(editDetail?.description),
        storage_area_1_id: checkNull(editDetail?.storage_area_1_id),
        storage_area_2_id: checkNull(editDetail?.storage_area_2_id),
        notes: checkNull(editDetail?.notes),
        ingredient_conv_multiplier: checkArray(
          editDetail?.ingredient_conv_multiplier
        )
          ? editDetail?.ingredient_conv_multiplier.map((ingredientConv) => {
              return {
                id: checkNull(ingredientConv?.id),
                supplier_id: checkNull(ingredientConv?.supplier_id),
                link_type: checkNull(ingredientConv?.link_type),
                linked_inventory_id: checkNull(
                  ingredientConv?.linked_inventory_id
                ),
                linked_supplier_id: checkNull(
                  ingredientConv?.linked_supplier_id
                ),
                measurement_unit_id: checkNull(
                  ingredientConv?.measurement_unit_id
                ),
                new_measurement_unit: checkNull(
                  ingredientConv?.new_measurement_unit
                ),
                purchase_price: checkNull(ingredientConv?.purchase_price),
                min_order_qty: checkNull(ingredientConv?.min_order_qty),
                con_multiplier: checkNull(ingredientConv?.con_multiplier),
                measurement_price: checkNull(ingredientConv?.measurement_price),
                deal_available: checkNull(ingredientConv?.deal_available),
                every_buy: checkNull(ingredientConv?.every_buy),
                you_get: checkNull(ingredientConv?.you_get),
              };
            })
          : [],
      };
      resetAddIngredientHandler(newEditDetail);
    }
  }, [ingredient_details]);

  const initialConvMultiForm = {
    id: "",
    supplier_id: "",
    link_type: "",
    linked_inventory_id: "",
    linked_supplier_id: "",
    measurement_unit_id: "",
    new_measurement_unit: "",
    purchase_price: "",
    min_order_qty: "",
    con_multiplier: "",
    measurement_price: "",
    deal_available: "",
    every_buy: "",
    you_get: "",
  };

  const initialAddIngredientForm = {
    id: "",
    status: 0,
    ingredient_name: "",
    category_id: "",
    measurement_unit_id: "",
    non_cogs: "",
    applicable_to: "",
    description: "",
    storage_area_1_id: "",
    storage_area_2_id: "",
    notes: "",
    ingredient_conv_multiplier: [],
  };
  const [addIngredientInputForm, setAddIngredientInputForm] = useState(
    initialAddIngredientForm
  );

  const {
    register: addIngredientReg,
    formState: { errors: addIngredientErrors },
    handleSubmit: addIngredientSubmit,
    control: addIngredientControl,
    setValue: addIngredientSetValue,
    reset: addIngredientReset,
    trigger: addIngredientTrigger,
  } = useForm({
    resolver: yupResolver(addIngredientSchema),
    defaultValues: initialAddIngredientForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeAddIngredientInputHandler = (input, val) => {
    if (input == "storage_area_1_id" && val == "1") {
      setStorageAreaType(1);
      closeStorageAreaModal(true);
    } else if (input == "storage_area_2_id" && val == "2") {
      setStorageAreaType(2);
      closeStorageAreaModal(true);
    } else {
      addIngredientSetValue(input, val);
      setAddIngredientInputForm((prevState) => ({
        ...prevState,
        [input]: val,
      }));
    }
  };

  const resetAddIngredientHandler = (resetVal = initialAddIngredientForm) => {
    setAddIngredientInputForm(resetVal);
    addIngredientReset(resetVal);
  };

  const deleteIngreHandler = (accId) => {
    // dispatch(deleteFinanceReconcileSettings({ id: accId }));
  };
  const addIngreSubmitHandler = (data) => {
    console.log("addIngreSubmitHandler", data);
    dispatch(saveMenuIngredientDetails(data));
  };

  const getErrorMsgForAddIngre = (input) => {
    let res = null;
    const errorMsg = addIngredientErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={addIngredientErrors} name={input} />;
    }
    return res;
  };

  // Ingredient Measure Unit
  const [selectedConvIndex, setSelectedConvIndex] = useState(-1);
  useEffect(() => {
    if (ingredient_conversion_details?.multiplier !== undefined) {
      if (checkNull(ingredient_conversion_details?.multiplier, false)) {
        const multiplierVal = decimalValue(
          ingredient_conversion_details?.multiplier,
          6,
          ""
        );
        const purchasePriceVal = decimalValue(
          addIngredientInputForm?.ingredient_conv_multiplier?.[
            selectedConvIndex
          ]?.purchase_price,
          6,
          ""
        );
        const perUnitPrice =
          purchasePriceVal * ingredient_conversion_details?.multiplier;
        measureChangeInputHandler(
          selectedConvIndex,
          "con_multiplier",
          multiplierVal
        );
        measureChangeInputHandler(
          selectedConvIndex,
          "measurement_price",
          perUnitPrice
        );
      } else {
        dispatch(
          showAlert(
            "Alert",
            "No conversion multiplier present, please enter manually"
          )
        );
        dispatch(changeMenuValue("ingredient_conversion_details", null));
      }
    }
  }, [ingredient_conversion_details]);

  const closeIngreMeasureUnitModal = useCallback(
    (value, isSave = false) => {
      dispatch(changeMenuValue("ingreMeasureUnitModal", value));
      if (value) {
        addToIngreMeasureUnit();
      } else if (!value && !isSave) {
        addToIngreMeasureUnit(true);
      }
      // initialServicePeriodModalState();
    },
    [ingreMeasureUnitModal, addIngredientInputForm]
  );

  const addToIngreMeasureUnit = (isDelete = false) => {
    const newConvObj = [...addIngredientInputForm.ingredient_conv_multiplier];
    if (isDelete) {
      newConvObj.pop();
      setSelectedConvIndex("");
    } else {
      newConvObj.push(initialConvMultiForm);
      const totalConvLength =
        addIngredientInputForm.ingredient_conv_multiplier.length;
      setSelectedConvIndex(totalConvLength);
    }
    changeAddIngredientInputHandler("ingredient_conv_multiplier", newConvObj);
  };

  async function submitIngreMeasureUnitModal() {
    const lastIndex = selectedConvIndex;
    const result = await addIngredientTrigger([
      `ingredient_conv_multiplier.${lastIndex}.supplier_id`,
      `ingredient_conv_multiplier.${lastIndex}.link_type`,
      `ingredient_conv_multiplier.${lastIndex}.linked_inventory_id`,
      `ingredient_conv_multiplier.${lastIndex}.linked_supplier_id`,
      `ingredient_conv_multiplier.${lastIndex}.measurement_unit_id`,
      `ingredient_conv_multiplier.${lastIndex}.new_measurement_unit`,
      `ingredient_conv_multiplier.${lastIndex}.purchase_price`,
      `ingredient_conv_multiplier.${lastIndex}.min_order_qty`,
      `ingredient_conv_multiplier.${lastIndex}.con_multiplier`,
      `ingredient_conv_multiplier.${lastIndex}.measurement_price`,
      `ingredient_conv_multiplier.${lastIndex}.deal_available`,
      `ingredient_conv_multiplier.${lastIndex}.every_buy`,
      `ingredient_conv_multiplier.${lastIndex}.you_get`,
    ]);
    if (result) closeIngreMeasureUnitModal(false, true);
  }

  const measureChangeInputHandler = (index, type, value) => {
    const checkIngreConv =
      addIngredientInputForm?.ingredient_conv_multiplier?.[index];
    let newIngreConv = { ...initialConvMultiForm };
    if (checkNull(checkIngreConv, false)) {
      if (type == "supplier_id") {
        newIngreConv = { ...newIngreConv, [type]: value };
        dispatch(checkSupplierDetails(`/${value}`));
      } else if (type == "measurement_unit_id") {
        dispatch(
          getConversionMultiplier({
            to_id: addIngredientInputForm?.measurement_unit_id,
            from_id: value,
          })
        );
        newIngreConv = { ...checkIngreConv, [type]: value };
      } else {
        newIngreConv = { ...checkIngreConv, [type]: value };
      }
      const addIngreConv = [
        ...addIngredientInputForm.ingredient_conv_multiplier,
      ];
      addIngreConv[index] = newIngreConv;
      changeAddIngredientInputHandler(
        "ingredient_conv_multiplier",
        addIngreConv
      );
    }
  };

  const editConvHandler = (convIdx) => {
    setSelectedConvIndex(convIdx);
    dispatch(changeMenuValue("ingreMeasureUnitModal", true));
  };
  const deleteConvHandler = (convIdx) => {
    if (addIngredientInputForm?.ingredient_conv_multiplier?.[convIdx]) {
      const addIngreConv = [
        ...addIngredientInputForm.ingredient_conv_multiplier,
      ];
      addIngreConv.splice(convIdx, 1);
      changeAddIngredientInputHandler(
        "ingredient_conv_multiplier",
        addIngreConv
      );
    }
  };

  const getLastConvIndex = () =>
    addIngredientInputForm.ingredient_conv_multiplier.length - 1;

  /* Storage Area Popups */
  useEffect(() => {
    setStorageAreaInput("");
    setStorageAreaType(1);
  }, [storageAreaModalModal]);
  useEffect(() => {
    if (checkNull(add_storage_new_id, false)) {
      changeAddIngredientInputHandler(
        storageAreaType == 1 ? "storage_area_1_id" : "storage_area_2_id",
        `${add_storage_new_id}`
      );
    }
  }, [add_storage_new_id]);

  const [storageAreaInput, setStorageAreaInput] = useState("");
  const [storageAreaType, setStorageAreaType] = useState(1);

  const closeStorageAreaModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("storageAreaModalModal", value));
    },
    [storageAreaModalModal]
  );

  const submitStorageAreaModal = () => {
    dispatch(
      saveStorageAreaDetails({ type: storageAreaType, name: storageAreaInput })
    );
  };

  const getErrorMsgForConvMultiplier = (input) => {
    const index = selectedConvIndex;
    let res = null;
    const errorMsg =
      addIngredientErrors?.ingredient_conv_multiplier?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = <ErrorContainer message={errorMsg?.message} name={input} />;
    }
    return res;
  };

  /* Backup Ingredients */
  const addBackupSchema = yup
    .object({
      id: yup.string().nullable(),
      ingredient_id: yup.string().required(),
      priority: yup.string().required(),
      backup_ingredient_id: yup.string().required(),
      measurement_unit_id: yup.string().required(),
      conversion_multiplier: yup.number().positive().required(),
      conversion_units: yup.number().positive().required(),
      start_date: yup.string().required(),
      end_date: yup.string().required(),
    })
    .required();

  const initialAddBackupForm = {
    id: "",
    ingredient_id: id,
    priority: "",
    backup_ingredient_id: "",
    measurement_unit_id: "",
    conversion_multiplier: "",
    conversion_units: "",
    backup_inventory_uom: "",
    start_date: "",
    end_date: "",
  };

  useEffect(() => {
    if (inventory_uom_details?.multiplier !== undefined) {
      if (checkNull(inventory_uom_details?.uom_id, false)) {
        changeAddBackupInputHandler(
          "measurement_unit_id",
          inventory_uom_details?.uom_id
        );
        changeAddBackupInputHandler(
          "backup_inventory_uom",
          inventory_uom_details?.uom_name
        );
      }
      if (checkNull(inventory_uom_details?.multiplier, false)) {
        changeAddBackupInputHandler(
          "conversion_multiplier",
          inventory_uom_details?.multiplier
        );
        changeAddBackupInputHandler(
          "conversion_units",
          inventory_uom_details?.multiplier
        );
      } else {
        dispatch(
          showAlert(
            "Alert",
            "No conversion multiplier present, please enter manually"
          )
        );
        dispatch(changeMenuValue("inventory_uom_details", null));
        changeAddBackupInputHandler("conversion_multiplier", "");
        changeAddBackupInputHandler("conversion_units", "");
      }
    }
  }, [inventory_uom_details]);

  const [addBackupInputForm, setAddBackupInputForm] =
    useState(initialAddBackupForm);

  const closeAddBackupModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("backupIngredientModal", value));
      resetAddBackupHandler();
    },
    [backupIngredientModal]
  );

  const {
    register: addBackupReg,
    formState: { errors: addBackupErrors },
    handleSubmit: addBackupSubmit,
    control: addBackupControl,
    setValue: addBackupSetValue,
    reset: addBackupReset,
    trigger: addBackupTrigger,
  } = useForm({
    resolver: yupResolver(addBackupSchema),
    defaultValues: initialAddBackupForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeAddBackupInputHandler = (input, val) => {
    addBackupSetValue(input, val);
    setAddBackupInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
    if (input == "backup_ingredient_id") {
      dispatch(
        getInventoryUom({
          ingredient_id: val,
          inventory_uom: addIngredientInputForm?.measurement_unit_id,
        })
      );
    }
  };

  const resetAddBackupHandler = (resetVal = initialAddBackupForm) => {
    setAddBackupInputForm(resetVal);
    addBackupReset(resetVal);
  };

  const addBackupSubmitHandler = (data) => {
    console.log("addBackupSubmitHandler", data);
    data.start_date = changeDateFormat(data.start_date, "yyyy-MM-DD");
    data.end_date = changeDateFormat(data.end_date, "yyyy-MM-DD");
    dispatch(saveBackupIngredient(data));
  };

  const deleteBackupHandler = (backId) => {
    // dispatch(deleteFinanceReconcileSettings({ id: backId }));
  };
  const editBackupHandler = (backIngre) => {
    closeAddBackupModal(true);
    const newEditBack = {
      id: checkNull(backIngre?.id),
      ingredient_id: id,
      priority: checkNull(backIngre?.priority),
      backup_ingredient_id: checkNull(backIngre?.backup_ingredient_id),
      measurement_unit_id: checkNull(backIngre?.measurement_unit_id),
      conversion_multiplier: checkNull(backIngre?.conversion_multiplier),
      conversion_units: checkNull(backIngre?.conversion_units),
      backup_inventory_uom: checkNull(backIngre?.backup_inventory_uom),
      start_date: checkNull(backIngre?.start_date, false)
        ? moment(backIngre?.start_date).toDate()
        : "",
      end_date: checkNull(backIngre?.end_date, false)
        ? moment(backIngre?.end_date).toDate()
        : "",
    };
    resetAddBackupHandler(newEditBack);
  };

  const getErrorMsgForAddBackup = (input) => {
    let res = null;
    const errorMsg = addBackupErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={addBackupErrors} name={input} />;
    }
    return res;
  };
  /* Backup Ingredients END */

  const getListOfRecipes = () => {
    let res = null;
    if (ingredient_details?.totalRelated) {
      res = checkArray(ingredient_details?.totalRelated)
        ? ingredient_details?.totalRelated.map((totalR, backIndex) => {
            if (totalR?.menu_item) {
              const menuItemObj = totalR?.menu_item;
              return (
                <tr>
                  <td>
                    <span>Menu Item</span>
                  </td>
                  <td>{checkNull(menuItemObj?.other_category?.name)}</td>
                  <td>{checkNull(menuItemObj?.menu_item_name)}</td>
                  <td>
                    {menuItemObj?.component_list_item?.measurement_choice_id ==
                    1
                      ? `{${menuItemObj?.component_list_item?.unit_amount} ${menuItemObj?.measurement_unit?.fullname}}`
                      : menuItemObj?.component_list_item
                          ?.measurement_choice_id == 2
                      ? `{${menuItemObj?.component_list_item?.unit_amount} ${
                          ingredient_details?.measurementUnits_small_name?.[
                            menuItemObj?.component_list_item
                              ?.temp_measurement_unit_id
                          ]
                        }}`
                      : ""}
                  </td>
                  <td>
                    {decimalValue(
                      menuItemObj?.component_list_item?.item_component_cost,
                      4,
                      getMerchantCurrencySymbol(user_details)
                    )}
                  </td>
                </tr>
              );
            } else {
              const recipeObj = totalR?.recipe;
              return (
                <tr>
                  <td>
                    <span>Recipe</span>
                  </td>
                  <td>{checkNull(recipeObj?.other_category?.name)}</td>
                  <td>{checkNull(recipeObj?.recipe_name)}</td>
                  <td>
                    {recipeObj?.ingredients_recipe?.measurement_choice_id == 1
                      ? `{${recipeObj?.ingredients_recipe?.amount_used} ${recipeObj?.measurement_unit?.fullname}}`
                      : recipeObj?.ingredients_recipe?.measurement_choice_id ==
                        2
                      ? `{${recipeObj?.ingredients_recipe?.amount_used} ${
                          ingredient_details?.measurementUnits_small_name?.[
                            recipeObj?.ingredients_recipe
                              ?.temp_measurement_unit_id
                          ]
                        }}`
                      : ""}
                  </td>
                  <td>
                    {decimalValue(
                      recipeObj?.ingredients_recipe?.cost_per_recipe,
                      4,
                      getMerchantCurrencySymbol(user_details)
                    )}
                  </td>
                </tr>
              );
            }
          })
        : null;
    }
    return res;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        {console.log(
          "ingredient_conv_multiplier",
          addIngredientInputForm?.ingredient_conv_multiplier
        )}
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <form onSubmit={addIngredientSubmit(addIngreSubmitHandler)}>
                <div class="row mx-0">
                  <h4 class="event-alert">Ingredient Info </h4>
                  <div class="col-md-6">
                    <ul class="ingredient-info edit-shift">
                      <li>
                        <label class="required">Ingredient Name</label>
                        <div class="input-group">
                          <input
                            type="hidden"
                            name="data[Ingredient][referer]"
                            value="https://uat.gogmgo.com/ingredients"
                            class="yeOldeReferer"
                            id="IngredientReferer"
                          />{" "}
                          <input
                            name="data[Ingredient][ingredient_name]"
                            class="required"
                            // maxlength="100"
                            type="text"
                            id="IngredientIngredientName"
                            {...addIngredientReg("ingredient_name")}
                            value={addIngredientInputForm?.ingredient_name}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "ingredient_name",
                                e?.target?.value ?? ""
                              )
                            }
                          />{" "}
                          {getErrorMsgForAddIngre("ingredient_name")}
                        </div>
                      </li>
                      <li>
                        <label class="required">Category</label>
                        <div class="input-group select-div mb10">
                          <select
                            name="data[Ingredient][category_id]"
                            class="required"
                            id="IngredientCategoryId"
                            {...addIngredientReg("category_id")}
                            value={addIngredientInputForm?.category_id}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "category_id",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            {createSelectOptions(
                              ingredient_details?.categories
                            )}
                          </select>{" "}
                          {getErrorMsgForAddIngre("category_id")}
                        </div>
                      </li>
                      <li>
                        <label class="required">Inventory UoM</label>
                        <div class="input-group select-div mb10">
                          <select
                            name="data[MPrice][0][measurement_unit_id]"
                            class="required"
                            id="MPrice0MeasurementUnitId"
                            {...addIngredientReg("measurement_unit_id")}
                            value={addIngredientInputForm?.measurement_unit_id}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "measurement_unit_id",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            {createSelectOptions(
                              ingredient_details?.measurement_units
                            )}
                          </select>{" "}
                          {getErrorMsgForAddIngre("measurement_unit_id")}
                        </div>
                      </li>
                      <li>
                        <label class="required">Is Item Non-COGS?</label>
                        <div class="input-group select-div mb10 ">
                          <select
                            name="data[Ingredient][non_cogs]"
                            class="required"
                            id="IngredientNonCogs"
                            {...addIngredientReg("non_cogs")}
                            value={addIngredientInputForm?.non_cogs}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "non_cogs",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>{" "}
                          {getErrorMsgForAddIngre("non_cogs")}
                        </div>
                      </li>
                      <li>
                        <label class="required">Applicable To</label>
                        <div class="input-group select-div mb10 ">
                          <select
                            name="data[Ingredient][applicable_to]"
                            id="IngredientApplicableTo"
                            {...addIngredientReg("applicable_to")}
                            value={addIngredientInputForm?.applicable_to}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "applicable_to",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="All">All</option>
                            <option value="FOH">FOH</option>
                            <option value="BOH">BOH</option>
                          </select>{" "}
                          {getErrorMsgForAddIngre("applicable_to")}
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-6">
                    <ul class="ingredient-info edit-shift">
                      <li>
                        <label>Description</label>
                        <div class="input-group discipt" id="discipt">
                          <input
                            name="data[Ingredient][description]"
                            class=""
                            // maxlength="500"
                            type="text"
                            id="IngredientDescription"
                            {...addIngredientReg("description")}
                            value={addIngredientInputForm?.description}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "description",
                                e?.target?.value ?? ""
                              )
                            }
                          />{" "}
                          {getErrorMsgForAddIngre("description")}
                        </div>
                      </li>
                      <li>
                        <label>Storage Area #1</label>
                        <div class="input-group select-div mb10">
                          <select
                            name="data[Ingredient][storage_area_1_id]"
                            class=""
                            id="StorageArea1Id"
                            {...addIngredientReg("storage_area_1_id")}
                            value={addIngredientInputForm?.storage_area_1_id}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "storage_area_1_id",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            {createSelectOptions(
                              ingredient_details?.storage_area
                            )}
                          </select>{" "}
                          {getErrorMsgForAddIngre("storage_area_1_id")}
                        </div>
                      </li>
                      <li>
                        <label>Storage Area #2</label>
                        <div class="input-group select-div">
                          <select
                            name="data[Ingredient][storage_area_2_id]"
                            class=""
                            id="StorageArea2Id"
                            {...addIngredientReg("storage_area_2_id")}
                            value={addIngredientInputForm?.storage_area_2_id}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "storage_area_2_id",
                                e?.target?.value ?? ""
                              )
                            }
                          >
                            <option value="">Select</option>
                            {createSelectOptions(
                              ingredient_details?.storage_area
                            )}
                          </select>{" "}
                          {getErrorMsgForAddIngre("storage_area_2_id")}
                        </div>
                      </li>
                      <li>
                        <label>Notes</label>
                        <div class="input-group">
                          <textarea
                            name="data[Ingredient][notes]"
                            class=""
                            cols="45"
                            rows="5"
                            id="IngredientNotes"
                            {...addIngredientReg("notes")}
                            value={addIngredientInputForm?.notes}
                            onChange={(e) =>
                              changeAddIngredientInputHandler(
                                "notes",
                                e?.target?.value ?? ""
                              )
                            }
                          ></textarea>{" "}
                          {getErrorMsgForAddIngre("notes")}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <input
                  type="submit"
                  ref={formButtonRef}
                  style={{ display: "none" }}
                />
              </form>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">
                        Backup Ingredients
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="button" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th>Priority</th>
                                <th>Ingredient ID</th>
                                <th>Ingredient Name</th>
                                <th>Inventory UoM</th>
                                <th>
                                  Inventory UoM <br />
                                  Conversion Multiplier
                                </th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(backup_ingredient_list) &&
                                backup_ingredient_list.map(
                                  (backupIngre, backIndex) => {
                                    return (
                                      <tr>
                                        <td>
                                          {checkNull(backupIngre?.priority)}
                                        </td>
                                        <td>
                                          {checkNull(
                                            backupIngre?.backup_ingredient_id
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(
                                            backupIngre?.ingredient
                                              ?.ingredient_name
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(backupIngre?.unit?.name)}
                                        </td>
                                        <td>
                                          {checkNull(
                                            backupIngre?.conversion_multiplier
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(backupIngre?.start_date)}
                                        </td>
                                        <td>
                                          {checkNull(backupIngre?.end_date)}
                                        </td>
                                        <td>
                                          {
                                            <>
                                              <a
                                                class="circle_icon edit_tooltip"
                                                onClick={() =>
                                                  editBackupHandler(backupIngre)
                                                }
                                              >
                                                <i class="iconSprites edit-icon editBackup"></i>
                                              </a>
                                              {backIndex == 0 ? (
                                                <a class="circle_icon move_tooltip">
                                                  <i class="dropdown-green movedown"></i>
                                                </a>
                                              ) : (
                                                <a class="circle_icon move_tooltip">
                                                  <i class="dropdown-green moveup"></i>
                                                </a>
                                              )}
                                            </>
                                          }
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>

                        <div class="my-3">
                          <button
                            class="btn green-btn-revert add-plus addSp"
                            id="addCount"
                            type="button"
                            onClick={() => {
                              if (
                                checkNull(
                                  addIngredientInputForm?.measurement_unit_id,
                                  false
                                )
                              ) {
                                closeAddBackupModal(true);
                              } else {
                                dispatch(
                                  showAlert("Alert", "Select Inventory UoM")
                                );
                              }
                            }}
                          >
                            <i class="i-icon"> </i> Add Backup Ingredient
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">
                        {" "}
                        Ingredient Measurement Unit List{" "}
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="button" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th>Supplier Name</th>
                                <th>Unit Type</th>
                                <th>Purchase Price</th>
                                <th>Minimum Order Quantity</th>
                                <th>Conversion Multiplier</th>
                                <th>Per Unit Price</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(
                                addIngredientInputForm?.ingredient_conv_multiplier
                              ) &&
                                addIngredientInputForm?.ingredient_conv_multiplier.map(
                                  (conv, convIdx) => {
                                    return (
                                      <tr>
                                        <td>
                                          {checkNull(
                                            ingredient_details?.suppliers?.[
                                              conv?.supplier_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(
                                            ingredient_details
                                              ?.measurement_units?.[
                                              conv?.measurement_unit_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            conv?.purchase_price,
                                            6,
                                            getMerchantCurrencySymbol(
                                              user_details
                                            )
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(conv?.min_order_qty)}
                                        </td>
                                        <td>
                                          {checkNull(conv?.con_multiplier)}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            conv?.con_multiplier,
                                            6,
                                            getMerchantCurrencySymbol(
                                              user_details
                                            )
                                          )}
                                        </td>
                                        <td>
                                          <a
                                            class="editPm circle_icon"
                                            onClick={() =>
                                              editConvHandler(convIdx)
                                            }
                                          >
                                            {" "}
                                            <i class="iconSprites edit-icon"></i>{" "}
                                          </a>
                                          {/* <a
                                            class="deletePm circle_icon"
                                            onClick={() =>
                                              deleteConvHandler(convIdx)
                                            }
                                          >
                                            {" "}
                                            <i class="iconSprites delete-icon"></i>{" "}
                                          </a> */}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                        {console.log(
                          "addIngredientErrors",
                          addIngredientErrors
                        )}
                        {console.log("addBackupErrors", addBackupErrors)}
                        <div class="my-3">
                          <button
                            class="btn green-btn-revert add-plus addSp"
                            id="addCount"
                            type="button"
                            onClick={() => {
                              if (
                                checkNull(
                                  addIngredientInputForm?.measurement_unit_id,
                                  false
                                )
                              ) {
                                closeIngreMeasureUnitModal(true);
                              } else {
                                dispatch(
                                  showAlert("Alert", "Select Inventory UoM")
                                );
                              }
                            }}
                          >
                            <i class="i-icon"> </i> Add New Purchase Unit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="container px-0 d-flex col-12">
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button
                    type="button"
                    onClick={() => {
                      const chngeStatusData = { id: id, status: 1 };
                      if (
                        ingredient_details?.ingredient?.status?.status ==
                        "Active"
                      ) {
                        chngeStatusData.status = 2;
                      }
                      dispatch(changeIngredientStatus(chngeStatusData));
                    }}
                  >
                    {ingredient_details?.ingredient?.status?.status == "Active"
                      ? "Deactivate"
                      : "Activate"}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      if (checkNull(formButtonRef.current)) {
                        formButtonRef.current.click();
                      }
                    }}
                  >
                    Save
                  </button>
                  <button id="cancel" type="button">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingThree"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">
                        List Of Recipes And Menu Items Using Ingredient
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingThree"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="button" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Category</th>
                                <th>Recipe/Menu Item Name</th>
                                <th>Amount Used Per Serving</th>
                                <th>Total Cost Per Menu Item Serving</th>
                              </tr>
                            </thead>
                            <tbody>{getListOfRecipes()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingFour"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFour"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseFour"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0"> History </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingFour"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="button" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th>Start</th>
                                <th>End</th>
                                <th>Field</th>
                                <th>Value</th>
                                <th>Replacement Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(
                                addIngredientInputForm?.ingredient_conv_multiplier
                              ) &&
                                addIngredientInputForm?.ingredient_conv_multiplier.map(
                                  (conv, convIdx) => {
                                    return (
                                      <tr>
                                        <td>
                                          {checkNull(
                                            ingredient_details?.suppliers?.[
                                              conv?.supplier_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(
                                            ingredient_details
                                              ?.measurement_units?.[
                                              conv?.measurement_unit_id
                                            ]
                                          )}
                                        </td>
                                        <td>
                                          {decimalValue(
                                            conv?.purchase_price,
                                            6,
                                            getMerchantCurrencySymbol(
                                              user_details
                                            )
                                          )}
                                        </td>
                                        <td>
                                          {checkNull(conv?.min_order_qty)}
                                        </td>
                                        <td>
                                          {checkNull(conv?.con_multiplier)}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Add Measurement Unit`}
        open={ingreMeasureUnitModal}
        submitModal={submitIngreMeasureUnitModal}
        closeModal={closeIngreMeasureUnitModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <li>
              Supplier1
              <div class="input-wrap select-div">
                <select
                  name="data[supplier_id]"
                  class="required supplier_id select2-offscreen"
                  id="supplier_id"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "supplier_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.supplier_id
                  }
                >
                  <option value="">Select</option>
                  {createSelectOptions(ingredient_details?.suppliers)}
                </select>{" "}
                {getErrorMsgForConvMultiplier("supplier_id")}
              </div>
            </li>
            {/* {check_supplier_details == 1 && (
              <>
                <li>
                  Inventory Type
                  <div class="input-wrap select-div">
                    <select
                      name="data[link_type]"
                      class="required inv_type"
                      id="link_type"
                      onChange={(e) =>
                        measureChangeInputHandler(
                          selectedConvIndex,
                          "link_type",
                          e?.target?.value
                        )
                      }
                      value={
                        addIngredientInputForm?.ingredient_conv_multiplier?.[
                          selectedConvIndex
                        ]?.link_type
                      }
                    >
                      <option value="">Select</option>
                      {createSelectOptions(ingredient_details?.inventory_types)}
                    </select>{" "}
                    {getErrorMsgForConvMultiplier("link_type")}
                  </div>
                </li>
                <li>
                  Linked Inventory
                  <div class="input-wrap select-div">
                    <select
                      name="data[linked_inventory_id]"
                      class="linked_inventory"
                      id="linked_inventory_id"
                      onChange={(e) =>
                        measureChangeInputHandler(
                          selectedConvIndex,
                          "linked_inventory_id",
                          e?.target?.value
                        )
                      }
                      value={
                        addIngredientInputForm?.ingredient_conv_multiplier?.[
                          selectedConvIndex
                        ]?.linked_inventory_id
                      }
                    >
                      <option value="">Select</option>
                      {createSelectOptions(ingredient_details?.inventory_types)}
                    </select>{" "}
                    {getErrorMsgForConvMultiplier("linked_inventory_id")}
                    <input
                      type="hidden"
                      name="data[linked_supplier_id]"
                      id="linked_supplier_id"
                    ></input>
                  </div>
                </li>
              </>
            )} */}

            <li>
              Purchase Measurement Unit
              <div class="input-wrap select-div">
                <select
                  name="data[measurement_unit_id]"
                  class="m_id required"
                  id="measurement_unit_id"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "measurement_unit_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.measurement_unit_id
                  }
                >
                  <option value="">Select Measurement Unit</option>
                  {createSelectOptions(ingredient_details?.measurement_units)}
                </select>{" "}
                {getErrorMsgForConvMultiplier("measurement_unit_id")}
              </div>
            </li>
            {addIngredientInputForm?.ingredient_conv_multiplier?.[
              selectedConvIndex
            ]?.measurement_unit_id == "add_new" && (
              <li>
                Add Purchase Measurement Unit
                <div class="input-group">
                  <input
                    name="data[new_measurement_unit]"
                    class="required"
                    // maxlength="100"
                    type="text"
                    id="new_m_id"
                    onChange={(e) =>
                      measureChangeInputHandler(
                        selectedConvIndex,
                        "new_measurement_unit",
                        e?.target?.value
                      )
                    }
                    value={
                      addIngredientInputForm?.ingredient_conv_multiplier?.[
                        selectedConvIndex
                      ]?.new_measurement_unit
                    }
                    readOnly={
                      checkNull(
                        ingredient_conversion_details?.multiplier,
                        false
                      )
                        ? true
                        : false
                    }
                  />
                  {getErrorMsgForConvMultiplier("new_measurement_unit")}
                </div>
              </li>
            )}

            <li>
              Purchase Price
              <div class="input-group">
                <input
                  name="data[purchase_price]"
                  class="purchase_price number currency_ing required"
                  type="text"
                  id="purchase_price"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "purchase_price",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.purchase_price
                  }
                />
                {getErrorMsgForConvMultiplier("purchase_price")}
              </div>
            </li>
            <li>
              Minimum Order Quantity
              <div class="input-group">
                <input
                  name="data[min_order_qty]"
                  class="number required currency"
                  type="text"
                  id="min_order_qty"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "min_order_qty",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.min_order_qty
                  }
                />
                {getErrorMsgForConvMultiplier("min_order_qty")}
              </div>
            </li>
            <li>
              Inventory Uo M Conversion Multiplier
              <div class="input-group">
                <input
                  name="data[con_multiplier]"
                  class="con_multiplier number required"
                  type="text"
                  id="con_multiplier"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "con_multiplier",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.con_multiplier
                  }
                />
                {getErrorMsgForConvMultiplier("con_multiplier")}
              </div>
            </li>
            <li>
              Inventory Unit Price
              <div class="input-group">
                <input
                  name="data[measurement_price]"
                  class="measurement_price number required"
                  type="text"
                  id="measurement_price"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "measurement_price",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.measurement_price
                  }
                />
                {getErrorMsgForConvMultiplier("measurement_price")}
              </div>
            </li>
            <li>
              Supplier Purchase Deal Available?
              <div class="input-wrap select-div">
                <select
                  name="data[deal_available]"
                  class="m_id required"
                  id="deal_available"
                  onChange={(e) =>
                    measureChangeInputHandler(
                      selectedConvIndex,
                      "deal_available",
                      e?.target?.value
                    )
                  }
                  value={
                    addIngredientInputForm?.ingredient_conv_multiplier?.[
                      selectedConvIndex
                    ]?.deal_available
                  }
                >
                  <option value="">Select</option>
                  {createSelectOptions({ 0: "No", 1: "Yes" })}
                </select>{" "}
                {getErrorMsgForConvMultiplier("deal_available")}
              </div>
            </li>
            {addIngredientInputForm?.ingredient_conv_multiplier?.[
              selectedConvIndex
            ]?.deal_available == "1" && (
              <li class="deal-options">
                <div class="span2 right-arrows-sec mr-3">
                  <div class="input-wrap">
                    <label for="every_buy" class="required">
                      For Every [#] You Buy
                    </label>
                    <input
                      name="data[every_buy]"
                      id="every_buy"
                      class="required number"
                      placeholder=""
                      type="text"
                      onChange={(e) =>
                        measureChangeInputHandler(
                          selectedConvIndex,
                          "every_buy",
                          e?.target?.value
                        )
                      }
                      value={
                        addIngredientInputForm?.ingredient_conv_multiplier?.[
                          selectedConvIndex
                        ]?.every_buy
                      }
                    />{" "}
                    {getErrorMsgForConvMultiplier("every_buy")}
                  </div>
                </div>
                <div class="span2 ml-3">
                  <div class="input-wrap">
                    <label for="you_get" class="required">
                      You Get [#] Free
                    </label>
                    <input
                      name="data[you_get]"
                      id="you_get"
                      class="required number"
                      placeholder=""
                      type="text"
                      onChange={(e) =>
                        measureChangeInputHandler(
                          selectedConvIndex,
                          "you_get",
                          e?.target?.value
                        )
                      }
                      value={
                        addIngredientInputForm?.ingredient_conv_multiplier?.[
                          selectedConvIndex
                        ]?.you_get
                      }
                    />{" "}
                    {getErrorMsgForConvMultiplier("you_get")}
                  </div>
                </div>
              </li>
            )}
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Storage Area`}
        open={storageAreaModalModal}
        submitModal={submitStorageAreaModal}
        closeModal={closeStorageAreaModal}
        is_loading={is_add_storage_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <li>
              Storage Area
              <div class="input-group">
                <input
                  name="data[storage_area]"
                  class="required"
                  type="text"
                  id="storage_area"
                  onChange={(e) => setStorageAreaInput(e?.target?.value)}
                  value={storageAreaInput}
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Backup Ingredient`}
        open={backupIngredientModal}
        submitModal={addBackupSubmit(addBackupSubmitHandler)}
        closeModal={closeAddBackupModal}
        is_loading={backupIngredientModal_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <ListSelect
              label={"Backup Priority"}
              name="priority"
              className="required priority select2-offscreen"
              onChange={(e) =>
                changeAddBackupInputHandler("priority", e?.target?.value)
              }
              value={addBackupInputForm?.priority}
              options={createSelectOptions({
                1: 1,
                2: 2,
                3: 3,
                4: 4,
                5: 5,
                6: 6,
                7: 7,
                8: 8,
              })}
              errorMsg={getErrorMsgForAddBackup("priority")}
            />
            <ListSelect
              label={"Backup Ingredient Name"}
              name="backup_ingredient_id"
              className="required select2-offscreen"
              onChange={(e) =>
                changeAddBackupInputHandler(
                  "backup_ingredient_id",
                  e?.target?.value
                )
              }
              value={addBackupInputForm?.backup_ingredient_id}
              options={createSelectOptions(ingredient_details?.ingredient_list)}
              errorMsg={getErrorMsgForAddBackup("backup_ingredient_id")}
            />
            <ListInput
              label={"Backup Inventory UoM"}
              name="backup_inventory_uom"
              className="required"
              readonly={true}
              placeholder="Backup Inventory UoM"
              onChange={(e) =>
                changeAddBackupInputHandler(
                  "backup_inventory_uom",
                  e?.target?.value
                )
              }
              value={addBackupInputForm?.backup_inventory_uom}
              errorMsg={getErrorMsgForAddBackup("backup_inventory_uom")}
            />
            <ListInput
              label={"Inventory UoM Conversion Multiplier"}
              name="conversion_multiplier"
              className="number required"
              readonly={
                checkNull(inventory_uom_details?.multiplier, false)
                  ? true
                  : false
              }
              placeholder="Enter Conversion Multiplier"
              onChange={(e) =>
                changeAddBackupInputHandler(
                  "conversion_multiplier",
                  e?.target?.value
                )
              }
              value={addBackupInputForm?.conversion_multiplier}
              errorMsg={getErrorMsgForAddBackup("conversion_multiplier")}
            />
            <ListInput
              label={"Backup Conversion Units"}
              name="conversion_units"
              className="required"
              readonly={
                checkNull(inventory_uom_details?.multiplier, false)
                  ? true
                  : false
              }
              placeholder="Backup Conversion Units"
              onChange={(e) =>
                changeAddBackupInputHandler(
                  "conversion_units",
                  e?.target?.value
                )
              }
              value={addBackupInputForm?.conversion_units}
              errorMsg={getErrorMsgForAddBackup("conversion_units")}
            >
              {inventory_uom_details?.multiplier !== undefined &&
                checkNull(addIngredientInputForm?.measurement_unit_id, false) &&
                ingredient_details?.measurement_units?.[
                  addIngredientInputForm?.measurement_unit_id
                ] && (
                  <span id="unit_conv">
                    {
                      ingredient_details?.measurement_units?.[
                        addIngredientInputForm?.measurement_unit_id
                      ]
                    }
                  </span>
                )}
            </ListInput>
            <ListDateInput
              label={"Period Start"}
              name="start_date"
              autoComplete="new-password"
              className="required"
              dateFormat="yyyy-MM-dd"
              onChange={(val) => changeAddBackupInputHandler("start_date", val)}
              selected={addBackupInputForm?.start_date}
              errorMsg={getErrorMsgForAddBackup("start_date")}
            />
            <ListDateInput
              label={"Period End"}
              name="end_date"
              autoComplete="new-password"
              className="required"
              dateFormat="yyyy-MM-dd"
              onChange={(val) => changeAddBackupInputHandler("end_date", val)}
              selected={addBackupInputForm?.end_date}
              errorMsg={getErrorMsgForAddBackup("end_date")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
    </UserInterface>
  );
};
export default EditIngredient;
